import { Activity, Clock3, Flame } from 'lucide-react';

const STATUS_STYLES = {
  dead: 'border-yellow-500/50 bg-yellow-500/15 text-yellow-300',
  active: 'border-green-500/40 bg-green-500/10 text-green-400',
  new: 'border-cyan-500/40 bg-cyan-500/10 text-cyan-300',
  unpublished: 'border-yellow-500/40 bg-yellow-500/10 text-yellow-300',
};

const formatLastClicked = (value, fallbackDate) => {
  if (!value && fallbackDate) {
    return `Activity ${new Date(`${fallbackDate}T12:00:00`).toLocaleDateString([], { month: 'short', day: 'numeric' })}`;
  }
  if (!value) return 'Never clicked';
  return new Date(value).toLocaleString([], {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};

export const ArticleActivityTrail = ({ article, onOpenTrail }) => {
  const activity = article.activity || {};
  const trail = activity.trail_7d || [];
  const maxClicks = Math.max(...trail.map((item) => item.clicks || 0), 1);
  const statusLabel = activity.status === 'unpublished' ? 'Unpublished' : activity.status || 'New';

  return (
    <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-2" data-testid={`activity-trail-${article.id}`}>
      <span
        className={`border px-1.5 py-0.5 text-[9px] font-bold uppercase ${STATUS_STYLES[activity.status] || STATUS_STYLES.new}`}
        data-testid={`activity-status-${article.id}`}
      >
        {statusLabel}
      </span>
      <span className="inline-flex items-center gap-1 text-[10px] text-gray-400" data-testid={`last-clicked-${article.id}`}>
        <Clock3 size={11} className="text-gray-600" /> {formatLastClicked(activity.last_clicked_at, activity.last_activity_date)}
      </span>
      <span className="inline-flex items-center gap-1 text-[10px] text-orange-300" data-testid={`click-streak-${article.id}`}>
        <Flame size={11} /> {activity.streak_days || 0} day streak
      </span>
      <span className="text-[10px] text-gray-500" data-testid={`days-idle-${article.id}`}>
        {activity.days_idle ?? 0}d idle
      </span>
      <button
        type="button"
        onClick={() => onOpenTrail(article)}
        className="inline-flex items-center gap-1 text-[10px] text-gray-400 transition-colors hover:text-white"
        data-testid={`open-click-trail-${article.id}`}
      >
        <Activity size={11} /> 7-day trail
      </button>
      <div className="flex h-5 items-end gap-0.5" aria-label={`${activity.clicks_7d || 0} clicks in the last 7 days`} data-testid={`seven-day-bars-${article.id}`}>
        {trail.map((item) => (
          <span
            key={item.date}
            className={`w-1.5 ${item.clicks > 0 ? 'bg-green-500' : 'bg-[#333]'}`}
            style={{ height: `${Math.max(3, Math.round((item.clicks / maxClicks) * 20))}px` }}
            title={`${item.date}: ${item.clicks} clicks`}
          />
        ))}
      </div>
    </div>
  );
};